import { render, staticRenderFns } from "./caseGuide.vue?vue&type=template&id=4dbecfd6&lang=pug"
import script from "./caseGuide.vue?vue&type=script&lang=js"
export * from "./caseGuide.vue?vue&type=script&lang=js"
import style0 from "./caseGuide.vue?vue&type=style&index=0&id=4dbecfd6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports